import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';

export const useGetTimeInterval = (clubId: string) => {
  const { data, isLoading } = useQuery({
    ...planManagementQueries.timeInterval({
      clubId: clubId,
    }),
    select: (res) => {
      return {
        ...res,
        data: res.data,
      };
    },
    enabled: !!clubId,
  });
  return {
    data: data?.data || [],
    isLoading: isLoading,
  };
};
